export default __webpack_public_path__ + "static/media/prime.a98e75d0.svg";